import classNames from "classnames";

interface AlertProps {
  message: string;
  type: "success" | "error";
  show: boolean;
  autoClose: boolean;
  onClose: () => void;
}

const getAlertClassName = (type: AlertProps["type"]) => {
  return classNames(
    "z-[1000] w-[80%] rounded-[5px] border px-5 py-5 text-center",
    type === "success"
      ? "border-green-300 bg-green-200 text-green-800"
      : "border-red-300 bg-red-200 text-red-800"
  );
};

const Alert = (props: AlertProps) => {
  return (
    <div>
      {props.show && (
        <div
          className="fixed top-2 left-0 z-[1000] flex w-full justify-center"
        >
          <div className={getAlertClassName(props.type)}>
            <div>{props.message}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Alert;
